import { css } from '@emotion/react';

import { colors } from '../../global';

export const ButtonBoxed = css`
    text-decoration: none;

    &.pengestyrke {
        border: 3px solid ${colors.elephant};
        color: ${colors.elephant};
        background-color: ${colors.white};
        font-weight: 700;

        &:hover {
            text-decoration: underline;
            background-color: ${colors.elephant};
            color: ${colors.white};
        }
    }
`;
